import SVGInline from 'react-svg-inline';

import { PHOTO_PLACEHOLDER_TEXT } from 'legacy/appstore/constants';

import noPhotosIcon from 'legacy/assets/svg-inline/no-photos.svg';

import { PhotoPlaceholder as theme } from 'legacy/css-modules';

const PhotoPlaceholder = ({ icon, text = PHOTO_PLACEHOLDER_TEXT }) => {
  return (
    <div className={theme.PhotoPlaceholder}>
      <div className={theme.Content}>
        <SVGInline className={theme.Icon} svg={noPhotosIcon} />
        <span className={theme.Text}>{text}</span>
      </div>
    </div>
  );
};

export default PhotoPlaceholder;
